import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation, Navigate } from "react-router-dom";
import LoginRequired from "./LoginRequired";

const PrivateRoute = ({ children, currLang }) => {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
    const [redirecting, setRedirecting] = useState(false);
    const location = useLocation();

    console.log("PrivateRoute auth state:", { isLoading, isAuthenticated, redirecting });
    {/*}
    React.useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            loginWithRedirect({
                appState: { returnTo: location.pathname }
            });
        }
    }, [isLoading, isAuthenticated, loginWithRedirect, location]);
    */}

    if (isLoading) return <div>Loading...</div>;
    if (!isAuthenticated) return <LoginRequired currLang={currLang} currLocation={location.pathname} />;

    return children;
};

export default PrivateRoute;
